/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Landing_Compliance_GdprInputs */

const en_landing_compliance_gdpr = /** @type {(inputs: Landing_Compliance_GdprInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`GDPR`)
};

const de_landing_compliance_gdpr = /** @type {(inputs: Landing_Compliance_GdprInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`DSGVO`)
};

const fr_landing_compliance_gdpr = /** @type {(inputs: Landing_Compliance_GdprInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`GDPR`)
};

const es_landing_compliance_gdpr = /** @type {(inputs: Landing_Compliance_GdprInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`GDPR`)
};

const it_landing_compliance_gdpr = /** @type {(inputs: Landing_Compliance_GdprInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`GDPR`)
};

const nl_landing_compliance_gdpr = /** @type {(inputs: Landing_Compliance_GdprInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`GDPR`)
};

const pl_landing_compliance_gdpr = /** @type {(inputs: Landing_Compliance_GdprInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`GDPR`)
};

const fi_landing_compliance_gdpr = /** @type {(inputs: Landing_Compliance_GdprInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`GDPR`)
};

const da_landing_compliance_gdpr = /** @type {(inputs: Landing_Compliance_GdprInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`GDPR`)
};

const sv_landing_compliance_gdpr = /** @type {(inputs: Landing_Compliance_GdprInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`GDPR`)
};

/**
* | output |
* | --- |
* | "GDPR" |
*
* @param {Landing_Compliance_GdprInputs} inputs
* @param {{ locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }} options
* @returns {LocalizedString}
*/
export const landing_compliance_gdpr = /** @type {((inputs?: Landing_Compliance_GdprInputs, options?: { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Landing_Compliance_GdprInputs, { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_landing_compliance_gdpr(inputs)
	if (locale === "fr") return fr_landing_compliance_gdpr(inputs)
	if (locale === "es") return es_landing_compliance_gdpr(inputs)
	if (locale === "it") return it_landing_compliance_gdpr(inputs)
	if (locale === "nl") return nl_landing_compliance_gdpr(inputs)
	if (locale === "pl") return pl_landing_compliance_gdpr(inputs)
	if (locale === "fi") return fi_landing_compliance_gdpr(inputs)
	if (locale === "da") return da_landing_compliance_gdpr(inputs)
	if (locale === "sv") return sv_landing_compliance_gdpr(inputs)
	return en_landing_compliance_gdpr(inputs)
});